import { refineCommaInput, ShapeUtils } from '@ca/common'

import FormInput from '@ui/forms/Input/FormInput'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import useFrameSettingsForm, {
  EXT_MAX,
  EXT_MIN,
  getShRange,
} from './useFrameSettingsForm'
import InputsSection from '@ui/forms/InputsSection'
import FormMeasureSH from './FormMeasureSH'
import { useMeasurementMethod } from 'features/measurements/useMeasurementMethod'

const WIDTH_LABEL = 100

const FrameSettingsForm = (props: ReturnType<typeof useFrameSettingsForm>) => {
  const text = 'frame:settings'
  const { form, packageType, frame } = props
  const { t } = useTranslation(['ui', 'frame'])
  const shapes = ShapeUtils.getShapes(frame)
  const placeholderShape = `${EXT_MIN}  —  +${EXT_MAX} mm`
  const isShMeasurementEnabled = useMeasurementMethod('sh') !== 'disabled'

  // This is for text display only
  const extend_y = useWatch({ name: 'extend_y', control: form.control })
  const shRange = getShRange({
    packageType,
    frame,
    y_ext: Number(extend_y) || 0,
  })

  // prettier-ignore
  const placeholderSh = `${shRange.min.toFixed(2)}  —  ${shRange.max.toFixed(2)} mm`

  return (
    <View className="flex flex-col gap-8">
      <InputsSection
        title={t(`${text}.sh.header.title`)}
        desc={t(`${text}.sh.header.desc`)}
      >
        <FormInput
          labelWidth={WIDTH_LABEL}
          control={form.control}
          name="rightSH"
          inputMode="decimal"
          autoCorrect={false}
          autoCapitalize="none"
          label={`${t(`${text}.sh.inputs.rightSH.label`)}`}
          next="leftSH"
          refine={refineCommaInput}
          textEnd={placeholderSh}
        />
        <FormInput
          labelWidth={WIDTH_LABEL}
          control={form.control}
          name="leftSH"
          inputMode="decimal"
          autoCorrect={false}
          autoCapitalize="none"
          label={`${t(`${text}.sh.inputs.leftSH.label`)}`}
          refine={refineCommaInput}
          textEnd={placeholderSh}
        />
        {isShMeasurementEnabled && (
          <FormMeasureSH form={form} vboxMm={frame.vbox} />
        )}
      </InputsSection>
      <InputsSection
        title={t(`${text}.extend.header.title`)}
        desc={t(`${text}.extend.header.desc`)}
      >
        <FormInput
          labelWidth={WIDTH_LABEL}
          control={form.control}
          name="extend_x"
          inputMode="decimal"
          disabled={!shapes.x_ext}
          autoCorrect={false}
          autoCapitalize="none"
          label={t(`${text}.extend.inputs.extend_x.label`)}
          placeholder={!shapes.x_ext ? '—' : undefined}
          textEnd={!shapes.x_ext ? t('ui:unavailable') : placeholderShape}
        />
        <FormInput
          labelWidth={WIDTH_LABEL}
          control={form.control}
          name="extend_y"
          inputMode="decimal"
          disabled={!shapes.y_ext}
          autoCorrect={false}
          autoCapitalize="none"
          label={t(`${text}.extend.inputs.extend_y.label`)}
          placeholder={!shapes.y_ext ? '—' : undefined}
          textEnd={!shapes.y_ext ? t('ui:unavailable') : placeholderShape}
        />
      </InputsSection>
    </View>
  )
}

export default FrameSettingsForm
